module.exports = __webpack_public_path__ + "img/second.45d52ced.jpg";